<template>
  <div
    class="p-4 rounded-md h-full bg-depth-1/60 border border-transparent transition-[border-color] duration-300 hover:border-brand hover:bg-depth-1 hover:cursor-pointer min-h-48 md:min-h-0"
    @click="openDetails"
  >
    <div class="flex">
      <landing-page-modview-grid-mod-icon :item="item" md-resize />
      <div class="relative ml-4 pr-8 grow" :data-testid="testId([item.name])">
        <p class="mb-0 leading-tight">
          <b>{{ item.name }}</b>
          <br />
          <span class="text-brand">{{ recommendedRamSize }}</span>
        </p>

        <button
          class="absolute top-0 right-0 size-6 flex items-center justify-center rounded-md bg-brand text-onyx p-0"
          type="button"
          aria-label="Open mod details"
          @click="openDetails"
        >
          <fa-icon :icon="faPlus" class="size-3" aria-hidden="true" />
        </button>
      </div>
    </div>

    <landing-page-modview-grid-mod-tags class="mt-2" :tags="item.tags" />
  </div>
</template>

<script setup lang="ts">
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiMinecraftModpack } from '~/apollo/types/types';
import testId from '~/helpers/testid';

const props = defineProps<{
  item: StrapiMinecraftModpack;
}>();

const emit = defineEmits<{
  (e: 'select-mod', val: StrapiMinecraftModpack): void;
}>();

const { t } = useI18n();

const recommendedRamSize = computed(() =>
  t('general/ram/units/recommended', {
    units:
      props.item.unit === 'MB' ? props.item.memory / 1024 : props.item.memory,
    unitName: 'GB',
  }),
);

const openDetails = () => {
  emit('select-mod', props.item);
};
</script>
